export default function urlify(...path) {
  return path.length ? `/${path.join('/')}/` : '/';
}
